module.exports = __webpack_public_path__ + "img/carbon-nfts.dd01fff8.svg";